import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';


Fancybox.bind('[data-fancybox]', {

  Carousel: {
    Toolbar: {
      display: {
        left: ["infobar"],
        middle: [
        ],
        right: ["slideshow", "thumbs", "close"],
      },
    },
    Thumbs: false,   
    Arrows: {
      prevTpl: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M21 12H3M10 5L3 12L10 19" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
      nextTpl: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M3 12H21M14 5L21 12L14 19" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    },
  },
});